import { monthSort } from "./constant";

export const generateFiscalYearRanges = (numberOfYears = 5) => {
  const currentYear = new Date().getFullYear();
  const startYear = currentYear - 1; // Take the previous year as startYear
  const yearRanges = [];
  for (let i = 0; i < numberOfYears; i++) {
    const start = startYear - i;
    const end = start + 1;
    yearRanges.push(`${start}-${end.toString().slice(-2)}`);
  }
  return yearRanges;
};

export const generateCalenderYearRanges = (numberOfYears = 5) => {
  const currentYear = new Date().getFullYear();
  const startYear = currentYear; // Take the previous year as startYear
  const yearRanges = [];
  for (let i = 0; i < numberOfYears; i++) {
    let year = startYear - i;
    yearRanges.push(`${year}`);
  }
  return yearRanges;
};

const currentDate = new Date();
const year = new Date().getFullYear();
const month = currentDate.getMonth() + 1;

export const generateAnnualLabels = (currentYear = year) => {
  return Array.from({ length: 10 }, (_, i) => currentYear - 9 + i);
};

export const generateMonthYearLabels = (fromDate, toDate) => {
  let labels = [];
  let currentMonth = fromDate?.month || 1;
  let currentYear = fromDate?.year || year;

  while (
    currentYear < toDate?.year ||
    (currentYear === (toDate?.year || year) &&
      currentMonth <= (toDate?.month || month))
  ) {
    labels.push(
      `${monthSort[currentMonth - 1]}'${currentYear.toString().slice(-2)}`
    );
    currentMonth++;

    if (currentMonth > 12) {
      currentMonth = 1;
      currentYear++;
    }
  }
  return labels;
};

// export const currentYear = 2026 ;
export const currentYear = new Date().getFullYear();


export const fiscalYear=()=>{
  const currentYear = new Date().getFullYear();

    // Previous Fiscal Year: April (prev year) to March (current year)
    const fiscalYearStart = currentYear - 1;
    const fiscalYearEnd = currentYear;
    return `Fiscal Year (Apr ${fiscalYearStart} to Mar ${fiscalYearEnd})`;
}


export const getYearPeriods = () => {
  const currentYear = new Date().getFullYear();

  // For fiscal year: April (prev year) to March (current year)
  const fiscalYearStart = currentYear - 1;
  const fiscalYearEnd = currentYear;
  const fiscalYearPeriod = `Apr ${fiscalYearStart} to Mar ${fiscalYearEnd}`;

  // For calendar year: Jan (prev year) to Dec (prev year)
  const calendarYear = currentYear - 1;
  const calendarYearPeriod = `Jan ${calendarYear} to Dec ${calendarYear}`;

  return { fiscalYearPeriod, calendarYearPeriod };
};


export  const checkYear = (year) => {
  const { fiscalYearPeriod, calendarYearPeriod } = getYearPeriods();
  const currentYearNum = new Date().getFullYear();

  // Extract the year as a number from the string (e.g., "2022-2023" or "2023")
  const yearMatch = year && year.match(/\d{4}/g);
  if (!yearMatch) return false;
  const yearNum = parseInt(yearMatch[0], 10);

  // For fiscal year, check if the starting year is within 1 year of current year
  if (year?.includes(fiscalYearPeriod)) {
    return currentYearNum - yearNum <= 1;
  }
  // For calendar year, check if the year is within 1 year of current year
  if (year?.includes(calendarYearPeriod)) {
    return currentYearNum - yearNum <= 1;
  }
  return false;
};